module.exports = __webpack_public_path__ + "img/iconusername.70e9689f.svg";